var ImageMap = require('./react-image-map.js');
module.exports = { ImageMap: ImageMap };
